import { render, staticRenderFns } from "./CompanyIntroduce.vue?vue&type=template&id=53eaa600&scoped=true&"
import script from "./CompanyIntroduce.vue?vue&type=script&lang=js&"
export * from "./CompanyIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIntroduce.vue?vue&type=style&index=0&id=53eaa600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eaa600",
  null
  
)

component.options.__file = "CompanyIntroduce.vue"
export default component.exports